import IFPriceDisplayStyles from './if-price-display';

// Toggle accordion items
var countButtons = document.getElementsByClassName('circle-m');

for (var i = 0; i < countButtons.length; i++) {
  countButtons[i].addEventListener("click", function () {
    var qtyField = '';
    var otherContainer = '';
    var newValue = 0;

    if (this.classList.contains('sixteen')) {
      qtyField = 'SixteenFootCount';
      otherContainer = 'SevenFootCount';
    }
    if (this.classList.contains('seven')) {
      qtyField = 'SevenFootCount';
      otherContainer = 'SixteenFootCount';
    }

    var currentValue = parseInt(document.getElementById(qtyField).value);
    var otherValue = parseInt(document.getElementById(otherContainer).value);

    if (this.classList.contains('plus')) newValue = currentValue + 1;
    if (this.classList.contains('minus')) newValue = currentValue - 1;

    if (newValue <= 0) {
      if (otherValue == 0) {
        newValue = 1;
        document.getElementById('spanErrorMessage').classList.remove('hidden-field');
      }
      else {
        newValue = 0;
        document.getElementById('spanErrorMessage').classList.add('hidden-field');
      }
    }
    else if (!document.getElementById('spanErrorMessage').classList.contains('hidden-field')) {
      document.getElementById('spanErrorMessage').classList.add('hidden-field');
    }

    document.getElementById(qtyField).value = newValue;
  });
}
